import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
export function GuaranteeSection() {
  return <section aria-labelledby="garantia" className="bg-brand-steel" data-id="element-85" data-mp="4vrzzwt0kbqc">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-86" data-mp="9u39u7jb6m8k">
        <p className="text-[0.65rem] font-extrabold uppercase tracking-[0.16em] text-brand-blue" data-id="element-87" data-mp="etfxgui07xc7">
          Tu inversión está protegida
        </p>

        <Reveal className="mt-2 flex items-start gap-3 rounded-xl border-2 border-brand-navy bg-white p-3.5 text-left" data-id="element-88" data-mp="jrr7b58au7uf">
          <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-brand-navy" data-id="element-89" data-mp="nsazrvhxgna8">
            <ShieldCheckIcon size={20} className="text-brand-yellow" data-id="element-90" data-mp="sn6vp6qabusm" />
          </span>
          <div data-id="element-91" data-mp="xm1nuza56vpe">
            <h2 id="garantia" className="font-display text-lg uppercase leading-tight text-brand-carbon sm:text-xl" data-id="element-92" data-mp="xls07ickl0mv">
              🛡️ Garantía total de 7 días
            </h2>
            <p className="mt-1 text-[0.8rem] leading-snug text-brand-muted" data-id="element-93" data-mp="25rnf6olk22o0">
              Tienes 7 días para explorar los 6 tomos y los 5 bonos. Si
              consideras que el sistema no es adecuado para ti, puedes
              solicitar un reembolso dentro del período establecido según los
              términos de devolución.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}